var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 8.21C9.15625 8.21 7.29167 10.0746 7.29167 12.3767C7.29167 14.6788 9.15625 16.5433 11.4583 16.5433C13.7604 16.5433 15.625 14.6788 15.625 12.3767C15.625 10.0746 13.7604 8.21 11.4583 8.21ZM20.7708 11.335C20.5349 9.22263 19.5877 7.25327 18.0847 5.75031C16.5817 4.24734 14.6124 3.30012 12.5 3.06417V0.918335H10.4167V3.06417C8.30429 3.30012 6.33494 4.24734 4.83197 5.75031C3.32901 7.25327 2.38178 9.22263 2.14583 11.335H0V13.4183H2.14583C2.38178 15.5307 3.32901 17.5001 4.83197 19.003C6.33494 20.506 8.30429 21.4532 10.4167 21.6892V23.835H12.5V21.6892C14.6124 21.4532 16.5817 20.506 18.0847 19.003C19.5877 17.5001 20.5349 15.5307 20.7708 13.4183H22.9167V11.335H20.7708ZM11.4583 19.6683C7.42708 19.6683 4.16667 16.4079 4.16667 12.3767C4.16667 8.34542 7.42708 5.085 11.4583 5.085C15.4896 5.085 18.75 8.34542 18.75 12.3767C18.75 16.4079 15.4896 19.6683 11.4583 19.6683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFences);
export default __webpack_public_path__ + "static/media/fences.6b1c07231f49c3c8a0515d433e3f8b3b.svg";
export { ForwardRef as ReactComponent };